module.exports = __webpack_public_path__ + "img/19.c27c41cf.png";